import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" className="py-20 bg-white px-4" data-id="element-148">
      <div className="max-w-3xl mx-auto" data-id="element-149">
        <div className="bg-slate-50 border border-slate-200 rounded-3xl p-8 md:p-12 text-center shadow-sm relative overflow-hidden" data-id="element-150">
          <div className="absolute top-0 left-0 w-full h-2 bg-sky" data-id="element-151"></div>

          <div className="w-20 h-20 bg-sky/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-152">
            <ShieldCheck className="w-10 h-10 text-sky" data-id="element-153" />
          </div>

          <h2 className="text-3xl font-bold text-navy mb-6" data-id="element-154">
            7 días de garantía total
          </h2>

          <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-155">
            Descargás las guías, aplicás las herramientas en tu negocio. Si en
            los primeros 7 días sentís que no es lo que esperabas: te devolvemos
            el 100% de tu plata. Sin preguntas, sin formularios, sin drama.
          </p>

          <div className="bg-white border border-slate-200 rounded-xl p-4 mb-6 inline-block" data-id="element-156">
            <p className="text-slate-700 font-medium" data-id="element-157">
              Escribís a{' '}
              <a href="mailto:soportesaberclick@gmail.com" className="text-sky hover:underline" data-id="element-158">
                soportesaberclick@gmail.com
              </a>{' '}
              y listo. Así de simple.
            </p>
          </div>

          <p className="text-sm text-slate-500 font-medium" data-id="element-159">
            Dato de confianza: Tasa de devolución menor al 1% — la gran mayoría
            de quienes lo compran lo aplican y ven resultados.
          </p>
        </div>
      </div>
    </section>;
}